module.exports = __webpack_public_path__ + "img/home-help4.dbec3ca8.png";